<template>
  <div class="flex flex-col relative">
    <div class="flex">
      <ApproveBtn
        :item="{ ...approver, approverId: approver.id }"
        :approval-settings="approvalSettings"
        @refresh="$emit('refresh')"
      >
        <template v-slot:trigger="{ onUpdate }">
          <MButton
            v-if="status === 'pending'"
            class="mr-2"
            variant="success"
            @click="onUpdate"
          >
            <MIcon name="check" />
            {{ $t('approve') }}
          </MButton>
        </template>
      </ApproveBtn>
      <RejectBtn
        :item="{ ...approver, approverId: approver.id }"
        :approval-settings="approvalSettings"
        @refresh="$emit('refresh')"
      >
        <template v-slot:trigger="{ onUpdate }">
          <MButton
            v-if="status === 'pending'"
            variant="error"
            class="mr-2"
            @click="onUpdate"
          >
            <MIcon name="times" />
            {{ $t('reject') }}
          </MButton>
        </template>
      </RejectBtn>
      <ReferBackBtn
        :item="{ ...approver, approverId: approver.id }"
        :approval-settings="approvalSettings"
        @refresh="$emit('refresh')"
      >
        <template v-slot:trigger="{ onUpdate }">
          <MButton
            v-if="status === 'pending'"
            variant="error"
            @click="onUpdate"
          >
            <MIcon name="undo" />
            {{ $t('refer_back') }}
          </MButton>
        </template>
      </ReferBackBtn>
      <StatusIcon v-if="status !== 'pending'" :status="status" show-status />
    </div>
    <slot name="delegator-info"></slot>
  </div>
</template>

<script>
import StatusIcon from '@components/approval/components/approval-status-icon'
import ApproveBtn from '../components/approve-btn.vue'
import RejectBtn from '../components/reject-btn.vue'
import ReferBackBtn from '../components/refer-back-btn.vue'
export default {
  name: 'ApprovalDecisionAction',
  components: { StatusIcon, ApproveBtn, RejectBtn, ReferBackBtn },
  props: {
    status: { type: String, required: true },
    approvalSettings: { type: Object, required: true },
    approver: { type: Object, required: true },
  },
}
</script>
